export default "__VITE_ASSET__COBx7_DV__"